import { MetricsChartCard } from '@/components/ui/metrics-chart-card';

import { METRIC_TYPES } from '../config/chart-config';

import { TabType } from '@/routes/dashboards/shared-types';

import { ChartOnlyLayout } from './chart-layouts/chart-only';

export interface MetricsDataPoint {
  date: string;
  [METRIC_TYPES.LIFECYCLE_REVENUE]?: number;
  [METRIC_TYPES.FLOWS_REVENUE]?: number;
  [METRIC_TYPES.TOTAL_ROI]?: number;
  [METRIC_TYPES.ANON_VISITORS_RECOGNIZED]?: number;
  [METRIC_TYPES.CONTEXTUAL_EVENTS]?: number;
  [METRIC_TYPES.META_EVENTS]?: number;
  [METRIC_TYPES.TIKTOK_EVENTS]?: number;
  [METRIC_TYPES.SNAPCHAT_EVENTS]?: number;
  [METRIC_TYPES.META_PAGE_VIEW_EMQ_SCORE]?: number;
  [METRIC_TYPES.META_VIEW_CONTENT_EMQ_SCORE]?: number;
  [METRIC_TYPES.META_ADD_TO_CART_EMQ_SCORE]?: number;
  [METRIC_TYPES.META_INITIATE_CHECKOUT_EMQ_SCORE]?: number;
  [METRIC_TYPES.META_ADD_PAYMENT_INFO_EMQ_SCORE]?: number;
  [METRIC_TYPES.META_PURCHASE_EMQ_SCORE]?: number;
  [METRIC_TYPES.META_LEAD_EMQ_SCORE]?: number | null;
}

export interface RevenueMetricsChartProps {
  initialTab: TabType;
  data: MetricsDataPoint[];
  isLoading: boolean;
}

export const RevenueMetricsChart = ({ initialTab, data, isLoading }: RevenueMetricsChartProps) => {
  return (
    <MetricsChartCard title="" noBorder={false} isLoading={isLoading}>
      <ChartOnlyLayout data={data} initialTab={initialTab} />
    </MetricsChartCard>
  );
};
